module.exports = "https://assets.niwcorp.com/_next/static/images/ico-twitter-cb203bd2fc81decd2f542646a0c3ea3d.svg";